<section class="microsite_main_body">
    <div class="ms_mobile_wrapper">
        <!-- <a href="http://mswipe.com/">
            <img src="./assets/images/logo1.png" srcset="./assets/images/logo1@2x.png 2x" alt="logo">
        </a> -->
        <div class="ms_mob_right_stars">
            <img src="./assets/images/ms_stars.svg" alt="ms_stars">
        </div>
        <div class="ms_left1_top_mob">
            <img src="./assets/images/ms_bottom_img.svg" alt="ms_graphic">
        </div>
    </div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-6">
                <div class="microsite_left_section">
                    <div class="mob_logo_wrapper" *ngIf="micrositeData?.PBLData?.Brand_Url" [ngStyle]="{'background-image': 'url(' + encodeImgUrl(micrositeData?.PBLData?.Brand_Url) + ')'}">
                        <!-- <img src="{{micrositeData?.PBLData?.Brand_Url}}" alt="brand-logo"> -->
                    </div>
                    <div class="logo_wrapper" *ngIf="micrositeData?.PBLData?.Brand_Url">
                        <img src="{{micrositeData?.PBLData?.Brand_Url}}" alt="brand-logo">
                    </div>
                    <div class="ms_info_wrapper">
                        <div class="ms_title ms_title_business" *ngIf="micrositeData?.PBLData?.BusinessName">
                            {{micrositeData?.PBLData?.BusinessName}}
                        </div>

                        <div class="payment_popup_wrapper_mob" *ngIf="micrositeData?.PBLData">
                            <div class="popup_details">
                                <div class="pay_title">
                                    Make payment
                                </div>
                                <div class="form_wrapper">
                                    <div class="form_div">
                                        <form #f="ngForm" (ngSubmit)="onSubmit(f)" *ngIf="!isPreview">
                                            <div class="form-group">
                                                <input type="number" class="form-control" id="amount" name="amount"
                                                    placeholder="Enter amount" autocomplete="off"
                                                    [(ngModel)]="payAmount" [disabled]="isPreview" required pattern="^([0-9]*|\d*\.\d{1}?\d*)$">
                                            </div>
                                            <button type="submit" [disabled]="!payAmount" *ngIf="!isPreview"
                                                [ngClass]="{'disabled': !payAmount}">
                                                Pay now
                                            </button>
                                        </form>

                                        <form  *ngIf="isPreview">
                                            <div class="form-group">
                                                <input type="number" class="form-control" id="amount1" name="amount1"
                                                    placeholder="Enter amount" [disabled]="isPreview" required pattern="^([0-9]*|\d*\.\d{1}?\d*)$">
                                            </div>
                                            <button type="submit">
                                                Pay now
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div class="pay_footer">
                                <img src="./assets/images/m_pay_method.svg" alt="" width="190">
                            </div>
                        </div>

                        <div class="ms_title ms_title_mob" *ngIf="micrositeData?.PBLData?.AboutUs">
                            About us
                        </div>
                        <div class="ms_subtitle" *ngIf="micrositeData?.PBLData?.AboutUs">
                            {{micrositeData?.PBLData?.AboutUs}}
                        </div>
                    </div>
                    <div class="ms_info_wrapper"
                        *ngIf="micrositeData?.PBLData?.BuildingPlotNo || micrositeData?.PBLData?.LandMark || micrositeData?.PBLData?.StreetLocality">
                        <div class="ms_title">
                            Address
                        </div>
                        <div class="ms_subtitle">
                            <span *ngIf="micrositeData?.PBLData?.BuildingPlotNo">
                                {{micrositeData?.PBLData?.BuildingPlotNo}} ,
                            </span>
                            <span *ngIf="micrositeData?.PBLData?.LandMark">
                                {{micrositeData?.PBLData?.LandMark}} ,
                            </span>
                            <span *ngIf="micrositeData?.PBLData?.StreetLocality">
                                {{micrositeData?.PBLData?.StreetLocality}}
                            </span>
                        </div>
                    </div>
                    <div class="ms_map_wrapper">
                        <!-- src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15090.529561733589!2d72.8315902!3d18.9918357!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xe6198688a90b5ff4!2sMSWIPE%20-%20POS%20%26%20MPOS%20Machines%2C%20Card%20swipe%20machines%2C%20MQR%2C%20business%20loans!5e0!3m2!1sen!2sin!4v1596707563404!5m2!1sen!2sin" -->
                        <!-- <iframe *ngIf="mapUrl" [src]="mapUrl" width="100%" height="250" frameborder="0"
                        style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"
                        same-origin="true"></iframe> -->

                        <div id="map" class="map_wrapper"></div>
                        <div class="payment_popup_wrapper" *ngIf="micrositeData?.PBLData">
                            <div class="popup_details">
                                <div class="pay_title">
                                    Make payment
                                </div>
                                <div class="form_wrapper">
                                    <div class="total">
                                        Total
                                    </div>
                                    <div class="form_div">
                                        <form #f="ngForm" (ngSubmit)="onSubmit(f)" *ngIf="!isPreview">
                                            <div class="form-group">
                                                <input type="number" class="form-control" id="amount" name="amount"
                                                    placeholder="Enter amount" autocomplete="off"
                                                    [(ngModel)]="payAmount" required pattern="^([0-9]*|\d*\.\d{1}?\d*)$">
                                            </div>
                                            <button type="submit" [disabled]="!payAmount" *ngIf="!isPreview"
                                                [ngClass]="{'disabled': !payAmount}">
                                                Pay now
                                            </button>
                                        </form>

                                        <form  *ngIf="isPreview">
                                            <div class="form-group">
                                                <input type="number" class="form-control" id="amount1" name="amount1"
                                                    placeholder="Enter amount" [disabled]="isPreview" required pattern="^([0-9]*|\d*\.\d{1}?\d*)$">
                                            </div>
                                            <button type="submit">
                                                Pay now
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div class="pay_footer">
                                <img src="./assets/images/m_pay_method.svg" alt="" width="280">
                            </div>
                        </div>
                    </div>
                    <div class="ms_info_wrapper"
                        *ngIf="micrositeData?.PBLData?.FromTime && micrositeData?.PBLData?.ToTime">
                        <div class="ms_title">
                            Timings
                        </div>
                        <div class="ms_subtitle">
                            <span>
                                {{micrositeData?.PBLData?.FromTime}} Hrs
                            </span>
                            &nbsp; To &nbsp;
                            <span>
                                {{micrositeData?.PBLData?.ToTime}} Hrs
                            </span>
                        </div>
                    </div>
                    <div class="ms_shop_img_wrapper"
                        *ngIf="micrositeData?.PBLData?.Shop_Image_Inside_Url || micrositeData?.PBLData?.Shop_Image_Outside_Url">
                        <!-- <div class="ms_main_shop_img">
                            <img src="{{micrositeData?.PBLData?.Shop_Image_Inside_Url}}" alt=""
                                (click)="openImg(micrositeData?.PBLData?.Shop_Image_Inside_Url)">
                        </div> -->
                        <div class="ms_more_shop_img">
                            <div class="ms_img_list"
                                [ngStyle]="{'background-image': 'url(' + encodeImgUrl(micrositeData?.PBLData?.Shop_Image_Inside_Url) + ')'}"
                                (click)="openImg(micrositeData?.PBLData?.Shop_Image_Inside_Url)">
                                <!-- <img src="{{micrositeData?.PBLData?.Shop_Image_Inside_Url}}" alt="" (click)="openImg(micrositeData?.PBLData?.Shop_Image_Inside_Url)"> -->
                            </div>
                            <div class="ms_img_list"
                                [ngStyle]="{'background-image': 'url(' + encodeImgUrl(micrositeData?.PBLData?.Shop_Image_Outside_Url) + ')'}"
                                (click)="openImg(micrositeData?.PBLData?.Shop_Image_Outside_Url)">
                                <!-- <img src="{{micrositeData?.PBLData?.Shop_Image_Outside_Url}}" alt="" (click)="openImg(micrositeData?.PBLData?.Shop_Image_Outside_Url)"> -->
                            </div>
                            <!-- <div class="ms_img_list">
                                <img src="{{micrositeData?.PBLData?.Shop_Image_Outside_Url}}" alt="" (click)="openImg(micrositeData?.PBLData?.Shop_Image_Outside_Url)">
                            </div> -->
                        </div>
                        <div class="ms_shop_stars">
                            <img src="./assets/images/ms_stars.svg" alt="ms_stars">
                        </div>
                    </div>
                    <div class="ms_info_wrapper"
                        *ngIf="micrositeData?.PBLData?.LandLineNumber || micrositeData?.PBLData?.MobileNumber">
                        <div class="ms_title">
                            Contact Us:
                        </div>
                        <br class="d-lg-none">
                        <div class="ms_subtitle">
                            <div *ngIf="micrositeData?.PBLData?.EmailAddress">
                                <img src="./assets/images/ms_email.svg" alt="email"> <a
                                    href="mailto:{{micrositeData?.PBLData?.EmailAddress}}">{{micrositeData?.PBLData?.EmailAddress}}</a>
                            </div>
                            <br> <br class="d-lg-none">
                            <div *ngIf="micrositeData?.PBLData?.LandLineNumber || micrositeData?.PBLData?.MobileNumber">
                                <img src="./assets/images/ms_phone.svg" alt="phone">
                                <a href="tel:{{micrositeData?.PBLData?.MobileNumber}}"
                                    *ngIf="micrositeData?.PBLData?.MobileNumber">
                                    {{micrositeData?.PBLData?.MobileNumber}}
                                </a>
                                <a href="tel:{{micrositeData?.PBLData?.LandLineNumber}}"
                                    *ngIf="micrositeData?.PBLData?.LandLineNumber"> /
                                    {{micrositeData?.PBLData?.LandLineNumber}}
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="ms_info_wrapper"
                        *ngIf="micrositeData?.PBLData?.FaceBookProfileLink || micrositeData?.PBLData?.LinkedInProfileLink || micrositeData?.PBLData?.TwitterProfileLink || micrositeData?.PBLData?.InstagramProfileLink">
                        <div class="ms_title ms_title_two">
                            Share this on:
                        </div>
                        <div class="ms_subtitle">
                            <a target="_blank" href="{{micrositeData?.PBLData?.FaceBookProfileLink}}"
                                *ngIf="micrositeData?.PBLData?.FaceBookProfileLink">
                                <img src="./assets/images/ms_fb.svg" alt="facebook">
                            </a>
                            <a target="_blank" href="{{micrositeData?.PBLData?.LinkedInProfileLink}}"
                                *ngIf="micrositeData?.PBLData?.LinkedInProfileLink">
                                <img src="./assets/images/ms_ln.png" width="32px" alt="whatsapp">
                            </a>
                            <a target="_blank" href="{{micrositeData?.PBLData?.TwitterProfileLink}}"
                                *ngIf="micrositeData?.PBLData?.TwitterProfileLink">
                                <img src="./assets/images/ms_twit.svg" alt="twitter">
                            </a>
                            <a target="_blank" href="{{micrositeData?.PBLData?.InstagramProfileLink}}"
                                *ngIf="micrositeData?.PBLData?.InstagramProfileLink">
                                <img src="./assets/images/ms_insta.svg" alt="instagram">
                            </a>
                        </div>
                    </div>
                    <div class="ms_info_wrapper" *ngIf="micrositeData?.PBLData">
                        <div class="ms_title ms_title_two">
                            Terms & Conditions
                        </div>
                        <div class="ms_subtitle">
                            <div (click)="openTnC()" style="cursor: pointer;">
                                Click here to view terms and conditions
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 offset-lg-2 col-md-4 offset-md-2">
                <div class="microsite_right_section" *ngIf="micrositeData?.PBLData">
                    <div class="m_logo_right">
                        Powered by
                        <a href="http://mswipe.com/">
                            <img src="./assets/images/logo1.png" srcset="./assets/images/logo1@2x.png 2x" alt="logo" width="120">
                        </a>
                    </div>

                    <div class="ms_left1_btm">
                        <img src="./assets/images/ms_bottom_img.svg" alt="ms_graphic">
                    </div>
                    <div class="ms_left2_btm">
                        <img src="./assets/images/ms_bottom_img.svg" alt="ms_graphic">
                    </div>
                    <div class="ms_left1_stars">
                        <img src="./assets/images/ms_stars.svg" alt="ms_stars">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ms_right_btm">
        <img src="./assets/images/ms_bottom_img.svg" alt="ms_graphic">
    </div>
    <div class="ms_right_stars">
        <img src="./assets/images/ms_stars.svg" alt="ms_stars">
    </div>
    <div class="ms_mobile_wrapper">
        Powered by
        <a href="http://mswipe.com/">
            <img src="./assets/images/logo1.png" srcset="./assets/images/logo1@2x.png 2x" alt="logo" width="80">
        </a>
    </div>
</section>

<div class="img_modal_wrapper" *ngIf="imgModal">
    <div class="close" (click)="openImg(micrositeData?.PBLData?.Shop_Image_Inside_Url)">&times;</div>
    <div class="img_div">
        <img src="{{imgUrl}}" alt="">
    </div>
</div>

<div class="tnc_popup" *ngIf="tncModal">
    <div class="close" (click)="openTnC()">&times;</div>
    <pdf-viewer src="./assets/images/Draft_Microsite_Terms_and_Conditions-converted.pdf" [autoresize]="true" [original-size]="false"></pdf-viewer>
    <!-- <iframe src="./assets/images/Draft_Microsite_Terms_and_Conditions-converted.pdf" width="100%" height="100%" frameborder="0"></iframe> -->
</div>